import React, { useState } from 'react';
import { Palette } from 'lucide-react';
import ThemePicker from './ThemePicker';
import PrintButton from './PrintButton';

// Display names for the theme picker
const THEME_LABELS = {
  original:               'Classic Blue',
  'woods-earth':          'Woods & Earth',
  'coral-reef':           'Coral Reef',
  'southwest-desert':     'Southwest Desert',
  pride:                  'Pride',
  'transformative-teal':  'Transformative Teal',
  'warm-linen':           'Warm Linen',
  'violet-cyan':          'Violet & Cyan',
  'sage-clay':            'Sage & Clay',
  'slate-amber':          'Slate & Amber',
};

export default function AppHeader({
  user,
  currentView,
  setCurrentView,
  viewConfig,
  onLogout,
  currentTheme,
  onSelectTheme,
  // print context props (passed down from App.js)
  currentDate,
  selectedYear,
  selectedMonth,
}) {
  const [showThemePicker, setShowThemePicker] = useState(false);

  return (
    <>
      <div className="bg-white border-b border-slate-200 shadow-sm">
        {/* Top Logo Section - SIDE BY SIDE */}
        <div className="flex items-center justify-center px-6 py-4 gap-6">
          <img
            src="/logo.png"
            alt="On Purpose Planner"
            className="h-32 w-auto flex-shrink-0"
          />
          <div className="text-center">
            <h1
              className="text-4xl font-bold text-slate-800"
              style={{ fontFamily: 'Lucida Calligraphy, cursive' }}
            >
              On Purpose Planner
            </h1>
          </div>
        </div>

        {/* Navigation Tabs - CENTERED */}
        <div className="flex flex-col items-center justify-center px-6 py-4 border-t border-slate-100 bg-slate-50 gap-3">
          <div className="flex gap-2 flex-wrap justify-center">
            {Object.entries(viewConfig).map(([key, config]) => {
              const Icon = config.icon;
              const isActive = currentView === key;
              return (
                <button
                  key={key}
                  onClick={() => setCurrentView(key)}
                  style={isActive
                    ? { backgroundColor: 'var(--color-primary)', color: 'white' }
                    : {}}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                    isActive
                      ? 'shadow-md'
                      : 'text-slate-600 hover:bg-slate-200'
                  }`}
                >
                  <Icon size={16} />
                  {config.label}
                </button>
              );
            })}
          </div>

          {/* User Info + Print + Theme + Sign Out */}
          <div className="w-full flex items-center justify-between border-t border-slate-200 pt-3 mt-2">
            <p className="text-xs text-slate-600">{user?.email}</p>

            <div className="flex items-center gap-3">
              {/* Print Button */}
              <PrintButton
                user={user}
                currentView={currentView}
                currentDate={currentDate}
                selectedYear={selectedYear}
                selectedMonth={selectedMonth}
              />

              <span className="text-slate-300 text-xs">|</span>

              {/* Theme Picker Button */}
              <button
                onClick={() => setShowThemePicker(true)}
                title="Choose a color theme"
                className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-700 transition-colors px-2 py-1 rounded-lg hover:bg-slate-100"
              >
                <Palette size={14} />
                <span>Theme</span>
              </button>

              <span className="text-slate-300 text-xs">|</span>

              <button
                onClick={onLogout}
                className="text-xs text-slate-500 hover:text-red-600 transition-colors"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Theme Picker Modal */}
      {showThemePicker && (
        <ThemePicker
          currentTheme={currentTheme}
          onSelectTheme={onSelectTheme}
          onClose={() => setShowThemePicker(false)}
        />
      )}
    </>
  );
}
